import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { useLocation, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { Box, Text, Grid, Flex, useToast, Divider } from "@chakra-ui/react";
import '../../global/styles/custom-animations.scss'

import { getUserProfile } from '../../profile/actions/users-profile-actions';
import { sendCustomerSupportMessage, resetSendCustomerSupportMessageOutcome } from '../../global/actions/customer-support-actions'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { IoLogoSlack } from "react-icons/io5";
import { SiTelegram } from "react-icons/si";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { redirectToNewPage, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

function CustomerSupportContact({
	getUserProfile,
	sendCustomerSupportMessage,
	resetSendCustomerSupportMessageOutcome,
	// Redux
	isMobileView,
	sendCustomerSupportMessageOutcome,
	// userProfile,
	userAccountProfile
}) {
	const initRef = useRef(false);
	const userEmailRef = useRef("");
	const toast = useToast()
	const location = useLocation();

	const [clickCount, setClickCount] = useState(0)

	const { suggestedSupportMessage } = location.state || {};

	const [customerSupportMessage, setCustomerSupportMessage] = useState(suggestedSupportMessage ? suggestedSupportMessage : "")
	const [commsMethod, setCommsMethod] = useState("slack")
	const [providedContact, setProvidedContact] = useState("")

	const [emptyMessageError, setEmptyMessageError] = useState(false)
	const [emptyProvidedCommsError, setEmptyProvidedCommsError] = useState(false)
	const [showSupportRequestCreatedSuccess, setShowSupportRequestCreatedSuccess] = useState(false)



	// Fetch data
	useEffect(() => {
		if (getUserProfile && !initRef.current) {
			getUserProfile({
				getUserInfo: true
			})
			initRef.current = true
		}
	}, [getUserProfile])

	useEffect(() => {
		if (userAccountProfile && !userEmailRef.current) {
			const { userPersonalProfile } = userAccountProfile || {}
			userEmailRef.current = userPersonalProfile.email || ""
		}
	}, [userAccountProfile])

	const onChangeHandler = (event) => {

		switch (event.target.name) {
			case ('customer-support-message'): {
				setEmptyMessageError(false)
				setCustomerSupportMessage(event.target.value)
				break;
			}
			case ('preferred-comms-method'): {
				setEmptyProvidedCommsError(false)
				setProvidedContact(event.target.value)
				// setProvidedContact(true)
				break;
			}
			default: {
				break;
			}
		}
	};

	const handleSubmitMessage = () => {
		if (customerSupportMessage?.trim().length > 0 && providedContact) {
			sendCustomerSupportMessage({
				customerSupportMessage,
				preferredCommsMethod: commsMethod,
				preferredProvidedContact: providedContact
			})
		} else {
			if (!customerSupportMessage) setEmptyMessageError(true)
			if (!providedContact) setEmptyProvidedCommsError(true)
		}
	}

	const handlePickCommsMethod = (value) => {
		setEmptyProvidedCommsError(false)
		setProvidedContact(value === "email" ? userEmailRef.current : "")
		setCommsMethod(value)
		setClickCount(prevCount => prevCount + 1)
	}

	const renderInputRequired = () => {
		switch (commsMethod) {
			case ("slack"): {
				return (
					<Box className='fade-in' key={`slack-${clickCount}`}>
						<Box fontWeight='semibold' >By Slack</Box>
						<Box my='1em'>
							<LaunchdeckFormInput
								label='Slack account email'
								name={'preferred-comms-method'}
								onChange={onChangeHandler}
								value={providedContact}
								placeholder={`e.g. mySlackAccountEmail@company.com`}
								isRequired={true}

								errorLogic={emptyProvidedCommsError}
								errorMessage={`Please let us know how to get back to you`}
							/>
						</Box>
					</Box>
				)
			}
			case ("telegram"): {
				return (
					<Box className='fade-in' key={`telegram-${clickCount}`}>
						<Box fontWeight='semibold' >By Telegram</Box>
						<Box my='1em'>
							<LaunchdeckFormInput
								label='Telegram handle'
								name={'preferred-comms-method'}
								onChange={onChangeHandler}
								value={providedContact}
								placeholder={`e.g. @MyTelegramHandle`}
								isRequired={true}

								errorLogic={emptyProvidedCommsError}
								errorMessage={`Please let us know how to get back to you`}
							/>
						</Box>
					</Box>
				)
			}
			case ("email"): {
				return (
					<Box className='fade-in' key={`telegram-${clickCount}`}>
						<Box fontWeight='semibold' >By email</Box>
						<Box my='1em'>
							<LaunchdeckFormInput
								label='Your email'
								name={'preferred-comms-method'}
								onChange={onChangeHandler}
								value={providedContact}
								isDisabled={true}

							/>
						</Box>
					</Box>
				)
			}
			default: {
				return null;
			}
		}
	}

	useEffect(() => {
		if (sendCustomerSupportMessageOutcome) {
			const { sendNotificationStatus, sourceEvent } = sendCustomerSupportMessageOutcome || {};

			switch (sourceEvent) {
				case ("send-customer-support-message"): {
					if (sendNotificationStatus) {
						setShowSupportRequestCreatedSuccess(true)
					} else if (!sendNotificationStatus) {
						toast(
							triggerLaunchdeckToast({
								useCase: "show-error-state",
								bannerText: "Something went wrong",
								label: "Unfortunately something went wrong. Please try again later.",
								isMobileView
							})
						)
					}

					resetSendCustomerSupportMessageOutcome()
					break;
				}
				default: {
					console.log(`There is no such sourceEvent: ${sourceEvent}`)
					break;
				}
			}
		}
	}, [sendCustomerSupportMessageOutcome, toast, resetSendCustomerSupportMessageOutcome]);


	const renderSuccessState = () => {
		return (
			<Flex className="flip-in-ver-left" mt='2em' justify='center' align='center' py='2.75em' border='1px solid #E5EAEF' rounded='0.5em' bg='white'>
				<Flex direction='column' justify='center' align='center'>

					<Box as={IoMdCheckmarkCircleOutline} color='brandDark.500' boxSize="3em" />

					<Box fontWeight='400' lineHeight='1.5em' color='gray.500' py='1.5em'>
						Successfully submitted!
					</Box>

					<Box whiteSpace='nowrap' >
						<Flex className='create-new-category-button'
							onClick={() => redirectToNewPage(`/home`)}>
							<Box className='create-new-category-button__button-text'>Back to homepage</Box>
						</Flex>
					</Box>

				</Flex>
			</Flex>
		)
	}
	return (
		<Box bg='white' px='3%' pt='1.5em' pb='3em' minHeight='40em' rounded={8}>
			<	Text fontSize='1.5em' letterSpacing='1px' color='brand.500'>SUPPORT</Text>
			<Divider mb='2em' />

			{showSupportRequestCreatedSuccess === true ?
				renderSuccessState()
				:
				<>

					<Box mb='1em'>
						<Text fontWeight='semibold'>Your preferred communication method</Text>
						<Text fontSize='0.8em' color='gray.600' mb='0.8em'>Seek straight-forward solutions quickly from a human</Text>
					</Box>

					<Grid templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)"]} gap='0.5em' mt='1em'>
						<Flex justify='flex-start' align='center' border='1px solid' borderColor={commsMethod === "slack" ? "brand.500" : 'gray.300'} bg={commsMethod === "slack" ? "white" : 'gray.100'} boxShadow='xs' p='1em' rounded='0.25em' cursor="pointer" onClick={() => handlePickCommsMethod('slack')}>
							<Box as={IoLogoSlack} color={commsMethod === "slack" && 'brand.500'} />
							<Box ml='1em'>Slack</Box>
						</Flex>

						<Flex justify='flex-start' align='center' border='1px solid' borderColor={commsMethod === "telegram" ? "brand.500" : 'gray.300'} bg={commsMethod === "telegram" ? "white" : 'gray.100'} boxShadow='xs' p='1em' rounded='0.25em' cursor="pointer" onClick={() => handlePickCommsMethod('telegram')}>

							<Box as={SiTelegram} color={commsMethod === "telegram" && 'brand.500'} />
							<Box ml='1em'>Telegram</Box>
						</Flex>


						<Flex justify='flex-start' align='center' border='1px solid' borderColor={commsMethod === "email" ? "brand.500" : 'gray.300'} bg={commsMethod === "email" ? "white" : 'gray.100'} boxShadow='xs' p='1em' rounded='0.25em' cursor="pointer" onClick={() => handlePickCommsMethod('email')}>

							<Box as={MdOutlineMarkEmailUnread} color={commsMethod === "email" && 'brand.500'} />
							<Box ml='1em'>Email</Box>

						</Flex>
					</Grid>

					<Box mt='2em' mb='1em'>
						{renderInputRequired()}
					</Box>

					<Box mb='1em' mt='3em' >
						<Text fontWeight='semibold'>Talk to us</Text>
					</Box>

					<Box mt='1em' w='100%'>
						<LaunchdeckFormTextAreaInput
							label="Tell us what you're experiencing"
							name="customer-support-message"
							onChange={onChangeHandler}
							value={customerSupportMessage}

							errorLogic={emptyMessageError}
							errorMessage={`Please tell us what you are experiencing to help us provide better & quicker assistance`}
						/>
					</Box>


					<Flex direction='column' mt='1em' justify='center' alignItems='center'>
						<Flex justify={['center', 'flex-end', 'flex-end', 'flex-end']} w='100%'>
							<LaunchdeckButton bg='brand.500' color='white' onClick={() => handleSubmitMessage()} label='Seek support' />
						</Flex>
					</Flex>
				</>
			}

		</Box>



	)

}


const mapStateToProps = (state) => ({
	userAccountProfile: state.userProfile.accountUserProfile,
	sendCustomerSupportMessageOutcome: state.sendCustomerSupportMessageOutcome.results.data,
	isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getUserProfile,
			sendCustomerSupportMessage,
			resetSendCustomerSupportMessageOutcome
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerSupportContact))

